/**
 * Set a 3D Object and all its descendants to a given layer
 * @param obj
 * @param layer
 */
export const setObjectLayersDeep = (obj, layer) => {
  obj.layers.set(layer);
  obj.traverse((e) => e.layers.set(layer));
};

